export default __webpack_public_path__ + "picture-dummy.svg";